import React, { type FC, useState } from 'react';

import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Expander from '@amzn/meridian/expander';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import EmDash from 'src/components/shared/emdash';
import { getBodyLocationLabel } from 'src/utils/getBodyLocationLabel';

import CardHeader, { type CardHeaderProps } from './cardHeader';

interface RestrictionCardProps extends CardHeaderProps {
  endAt: string;
  hoursRestricted: string | null | undefined;
  bodyLocation: string | null | undefined;
  yesNoTypeTask?: boolean;
}

const RestrictionCard: FC<RestrictionCardProps> = ({
  bodyLocation,
  endAt,
  hoursRestricted,
  yesNoTypeTask,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Card spacingInset="100 500" minWidth="750px">
      <Expander type="list" open={isOpen} onChange={setIsOpen} title={<CardHeader {...props} />}>
        <Row spacing="600">
          <Column spacing="200">
            <Text color="secondary">End Date</Text>
            {endAt.length > 0 ? <Text>{endAt}</Text> : <EmDash />}
          </Column>
          <Column spacing="200">
            <Text color="secondary">Body Location</Text>
            {!!bodyLocation ? <Text>{getBodyLocationLabel(bodyLocation)}</Text> : <EmDash />}
          </Column>
          <Column spacing="200">
            <Text color="secondary">{yesNoTypeTask ? 'Yes/No' : 'Cannot perform exceeding (hrs)'}</Text>
            {(hoursRestricted?.length || 0) > 0 ? <Text>{hoursRestricted}</Text> : <EmDash />}
          </Column>
        </Row>
      </Expander>
    </Card>
  );
};

export default RestrictionCard;
